'use client'

import * as React from 'react'
import { Switch as RadixSwitch } from 'radix-ui'
import { mtc } from '../../../utils/style-helpers'
import { labelStyles, rootStyles, thumbStyles } from './styles'

interface SwitchProps extends React.ComponentPropsWithoutRef<
  typeof RadixSwitch.Root
> {
  label?: string
}

export const Switch = ({ className, label, ...props }: SwitchProps) => {
  return (
    <div className="flex items-center space-x-2">
      <RadixSwitch.Root className={mtc(rootStyles(), className)} {...props}>
        <RadixSwitch.Thumb className={mtc(thumbStyles())} />
      </RadixSwitch.Root>
      <label htmlFor={props.id} className={mtc(labelStyles())}>
        {label}
      </label>
    </div>
  )
}

Switch.displayName = 'Switch'
